export default "__VITE_ASSET__CtLtaDlv__"